import dynamic from 'next/dynamic';
import css from './index.module.scss';
import A from './components/A';

const PageConPc = dynamic(() => import('./indexDynamic'), {
    ssr: true,
});

export default function GlacierWaveTreaserH5(props: any) {
    return (
        <div className={css.glacierWaveTreaserH5}>
            <A stage={props?.curStage} />
            <PageConPc {...props} />
            <style jsx global>
                {`
                    .wbg {
                        display: none;
                    }
                `}
            </style>
        </div>
    );
}
